import React from "react";
import './Secfour.css';

export default function () {

    return (

        <section className="sec-4 mt-5">   {/* section 4 start with content */}

            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-12 col-md-6 pt-md-5">
                        <h2 className="pt-5 text-white ">Our Powerful app to connect it all </h2>
                        <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam </p>
                        <h3 className="text-white"> Download Now </h3>
                        <img src="images/app-store.png" alt="" className="img-fluid pe-md-3 pt-3"/>
                        <img src="images/play-store.png" alt=""  className="img-fluid pt-3"/>
                    </div>

                    <div className="col-12 col-md-5 pt-5">
                        <img src="images/slider-img.png" alt="" className="img-fluid pt-md-4"/>
                    </div>

                </div>

            </div>

        </section>

    )

}